import React from "react";
import { Edit2, Trash2, BellRing, Star } from "lucide-react";
import { DEAL_TYPES, DEAL_STAGES, isDue, eur, parisToday } from "@/lib/deals";

export default function DealRow({ deal: d, onEdit, onDelete, onStage, onReview }) {
  const due = isDue(d);
  const late = due && d.next_followup < parisToday();
  return (
    <div data-testid={`deal-row-${d.id}`} className={`bg-white border rounded-2xl p-5 flex flex-col lg:flex-row lg:items-center gap-4 transition-colors ${due ? "border-md-secondary/60" : "border-md-border hover:border-md-secondary/30"}`}>
      <div className="flex-1 min-w-0">
        <div className="flex flex-wrap items-center gap-2 mb-1">
          <span className="text-[10px] uppercase tracking-widest font-bold text-md-secondary">{DEAL_TYPES[d.type]}</span>
          {d.product && <span className="text-xs text-md-muted">· {d.product}</span>}
          {due && (
            <span data-testid={`deal-due-${d.id}`} className={`inline-flex items-center gap-1 text-[10px] uppercase font-bold px-2 py-0.5 rounded-full ${late ? "bg-red-50 text-red-700" : "bg-md-secondary/15 text-md-secondary"}`}>
              <BellRing className="w-3 h-3" /> {late ? "Relance en retard" : "Relance aujourd'hui"}
            </span>
          )}
        </div>
        <div className="font-serif text-lg text-md-primary truncate">{d.client_name}</div>
        <div className="text-xs text-md-muted">{[d.client_phone, d.client_email].filter(Boolean).join(" · ") || "—"}</div>
      </div>
      <div className="grid grid-cols-3 gap-4 text-sm lg:w-80">
        <Kpi k="Montant" v={eur(d.amount)} />
        <Kpi k="Frais + com." v={d.fees == null && d.commission == null ? "—" : eur((d.fees || 0) + (d.commission || 0))} />
        <Kpi k="Relance" v={d.next_followup ? new Date(d.next_followup).toLocaleDateString("fr-FR", { day: "2-digit", month: "short" }) : "—"} />
      </div>
      <div className="flex items-center gap-2 flex-shrink-0">
        <select data-testid={`deal-stage-select-${d.id}`} value={d.stage} onChange={(e) => onStage(d, e.target.value)} className={`text-xs font-semibold rounded-full px-3 py-2 border-0 cursor-pointer ${DEAL_STAGES[d.stage].cls}`}>
          {Object.entries(DEAL_STAGES).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
        </select>
        {d.stage === "signee" && d.client_email && (
          d.review_requested_at
            ? <span data-testid={`deal-review-sent-${d.id}`} title="Demande d'avis déjà envoyée" className="w-9 h-9 rounded-full grid place-items-center bg-emerald-50 text-emerald-600"><Star className="w-4 h-4 fill-current" /></span>
            : <button data-testid={`deal-review-${d.id}`} onClick={() => onReview(d)} title="Demander un avis Google" className="w-9 h-9 rounded-full grid place-items-center bg-md-secondary/15 text-md-secondary hover:bg-md-secondary/25"><Star className="w-4 h-4" /></button>
        )}
        <button data-testid={`deal-edit-${d.id}`} onClick={() => onEdit(d)} className="w-9 h-9 rounded-full grid place-items-center bg-md-primary text-white hover:bg-md-primaryHover"><Edit2 className="w-4 h-4" /></button>
        <button data-testid={`deal-delete-${d.id}`} onClick={() => onDelete(d)} className="w-9 h-9 rounded-full grid place-items-center bg-red-50 text-red-600 hover:bg-red-100"><Trash2 className="w-4 h-4" /></button>
      </div>
    </div>
  );
}

const Kpi = ({ k, v }) => (
  <div>
    <div className="text-[10px] uppercase tracking-widest text-md-muted">{k}</div>
    <div className="font-semibold text-md-primary">{v}</div>
  </div>
);
